<script setup>
import { cn } from "@/lib/utils";

const props = defineProps({
  class: { type: null, required: false },
});
</script>

<template>
  <div
    :class="
      cn(
        'vf-flex vf-flex-col-reverse sm:vf-flex-row sm:vf-justify-end sm:vf-gap-x-2',
        props.class
      )
    "
  >
    <slot />
  </div>
</template>
